import angular from 'angular';
import ResourcesModule from '../../resources/resources';
import template from './bidFunnel.html';

export class BidFunnelController {
    /* @ngInject */
    constructor($scope, Resource) {
        this.Resource = Resource;
    }
}

export let BidFunnelComponent = {
    template: () => { return template },
    controller: BidFunnelController,
    controllerAs: 'vm',
    bindings: {
        data: '=',
        date: '='
    }
};

export default angular.module('app.common.analytics.funnel', [
    ResourcesModule.name
]).component('bidFunnel', BidFunnelComponent);



/** WEBPACK FOOTER **
 ** ./src/common/bidFunnel/bidFunnel.js
 **/